import React from 'react';
import {DropzoneAreaBase} from "material-ui-dropzone";
import {MasterOfActsAPI} from "../../../../api/api";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {getHandbooks} from "../../../../redux/reducers/handbook-reducer";
import {useSelector} from "react-redux";
import {getProfile} from "../../../../redux/reducers/user-profile-reducer";
import {downloadViolationFile, getActs} from "../../../../redux/reducers/act-reducer";


const useStyles = makeStyles(() => (
    {
        previewChip: {
            minWidth: 160,
            maxWidth: 210
        }
    }
))


export const DragAndDropFilesUpload = ({content, label, name, value, setFieldValue, disabled}) => {
    const classes = useStyles()

    const {selectedHandbook} = useSelector(getHandbooks)
    const {user} = useSelector(getProfile)
    const {selectedAct} = useSelector(getActs)

    const onAddFile = async (newFiles) => {
        let acceptedFiles = []
        for (const newFile of newFiles) {
            const response = await MasterOfActsAPI.uploadViolationAttachment(newFile.file.name, newFile.file.type, selectedHandbook.id, selectedAct?.creator || user.id, newFile.file)
            if (response.status === 201) {
                acceptedFiles = [...acceptedFiles, {file: {name: newFile.file.name}, id: response.data.id}]
            }
        }
        setFieldValue(name, [...value, ...acceptedFiles])
    }

    const onDeleteFile = async (file) => {
        const response = await MasterOfActsAPI.deleteViolationAttachment(file.id)
        if (response.status === 203 || response.status === 204 || response.status === 202) {
            setFieldValue(name, value.filter(f => f !== file))
        }
    }

    const onDownloadFile = async (event) => {
        const filename = event.target.outerText
        const fileId = value.filter(f => f.file.name === filename)[0].id
        await downloadViolationFile(fileId)
    }

    return <DropzoneAreaBase
        fileObjects={value}
        
        dropzoneText={label}
        onAdd={onAddFile}
        onDelete={onDeleteFile}
        filesLimit={9}
        getFileLimitExceedMessage={(filesLimit) => `Превышено максимально допустимое количество файлов. Разрешено только ${filesLimit} `}
        getFileAddedMessage={(fileName) => `Файл ${fileName} успешно добавлен `}
        getFileRemovedMessage={(fileName) => `Файл ${fileName} удален `}
        getDropRejectMessage={(rejectedFile) => `Файл ${rejectedFile.name} был отклонен `}
        showPreviews={true}
        showPreviewsInDropzone={false}
        useChipsForPreview
        previewGridProps={{container: {spacing: 1, direction: 'row'}}}
        previewChipProps={
            {
                classes: {
                    root: classes.previewChip
                },
                onClick: onDownloadFile
            }}
        previewText="Загруженные файлы"
        dropzoneProps={{disabled: disabled}}
    />
}